import withQueryParams from "../../utils/withQueryParams";
import productPageBaseUri from "../../utils/productPageBaseUri";

class ClearanceServiceClient {
  constructor(integrationService) {
    this._integrationService = integrationService;
  }

  fetchPrices = async (productCode) => {
   const clearancePriceUrl = withQueryParams(
        `${productPageBaseUri}product/api/clearance/price`,
        {
          productCode: productCode
        });

    return this._integrationService.read({
      url: clearancePriceUrl,
      method: "GET",
      headers: {
        "Content-Type": "application/json;charset=UTF-8"
      }
    });
  }
}

export default ClearanceServiceClient;
